// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alumni+Sans:wght@400;500;600;800&family=Roboto:wght@300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.postPageAdContainer {
    /* border: 1px solid black; */
    margin: 10px 0;
  }
  .postPageAdContainer img {
    width: 100%;
  }
  .news-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-items: center;
    /* padding: 1rem 0; */
    /* border-bottom: 2px dotted #bdbdbd; */
    border-bottom: 1px dotted #122241;
    /* margin-bottom: 14px; */
  }
  .news-heading h2 {
    font-family: "Satoshi";
    font-size: 18px !important;
    font-style: normal;
    text-transform: uppercase !important;
    font-weight: 700;
    margin-bottom: 4px;
    /* line-height: 0rem; */
    /* display: block; */
    min-width: 30%;
    /* letter-spacing: 1px; */
  }
  .news-heading hr {
    /* width: 75%; */
    height: 1px;
    /* max-width: 490px; */
    width: 65%;
    /* height: 1px; */
    background: rgba(0, 0, 0, 1);
  }
  .post-related-news {
    /* background: #fafafa; */
    padding: 5px;
    border-radius: 5px;
  }
  .post-related-news .opinionLatestRight {
    width: 49%;
  }
  .news-content {
    /* background: #f5f5f5;
    padding: 16px; */
    border-radius: 8px;
  }
  .news-content ul {
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0px;
  }
  .news-content ul li {
    width: 48%;
    list-style: none;
    font-family: "Switzer-variable";
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.375rem;
    /* border-bottom: solid 1px #cacaca; */
    border-bottom: 1px dotted #122241;
    padding: 10px 0;
    cursor: pointer;
    display: flex;
    flex-direction: column;
  }
  .news-content ul li h3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 16px !important;
    line-height: 22px;
    -webkit-line-clamp: 3;
    color: #000;
    margin: 0px;
  }
  
  .postPage-main div {
    display: flex;
    justify-content: space-between;
    border-radius: 6px;
    background: #f8f8f8;
    /* padding: 5px 10px; */
  }
  .breadcrumb-item a {
    text-transform: capitalize;
    font-size: 12px;
    color: black;
    opacity: 100%;
    font-weight: 500;
  }
  .post-page-main-container {
    margin-top: 10px !important;
  }
  
  .postPage-main blockquote {
    padding-left: 15px;
    border-left: 7px solid #ccc7c7;
    border-radius: 2px;
  }
  .postPage-main .text-huge {
    font-size: xxx-large;
    font-weight: 800;
    line-height: 1;
  }
  .postPage-main h4 .image-style-align-left {
    vertical-align: baseline;
  }
  .img-main {
    width: 100%;
    border-radius: 6px;
    border: 1px solid #000;
    /* margin: 10px 0; */
    margin: 0px 0px 0px 0px;
    object-fit: cover;
    object-position: center 25%;
    /* height: 282px; */
    height: 380px;
  }
  @media (max-width: 600px) {
    .img-main {
      height: 210px;
    }
  }
  .postPage-main .text-small {
    font-size: 13px;
  }
  .postPage-main .big-img-container {
    display: block !important;
  }
  #post-content-ck-edit figure div {
    /* background: green !important; */
  }
  .media div {
    /* background: white !important; */
  }
  .post-img-caption {
    opacity: 70%;
    font-size: 12px;
    font-style: oblique;
    margin-bottom: 10px;
  }
  .image img {
    max-width: 95% !important;
    height: 100%;
  }
  .postPageByLine .author-details .author-name span {
    font-size: 14px !important;
  }
  .postPageByLine .author-details {
    font-size: 12px !important;
  }
  .postPageByLine .news-time {
    font-size: 12px !important;
  }
  #post-content-ck-edit {
    font-family: "Switzer-Variable";
    line-height: 28px;
  }
  
  #post-content-ck-edit img {
    max-width: 98%;
    height: auto;
  }
  
  #post-content-ck-edit .table table {
    border-collapse: collapse;
    width: 100%;
  }
  #post-content-ck-edit .table table td {
    border: 1px solid black;
    padding: 6px;
    text-align: left;
    font-size: 14px;
    line-height: 22px;
  }
  #post-content-ck-edit .table table td p {
    margin: 0px;
    font-size: 14px !important;
  }
  #post-content-ck-edit .image-style-align-center {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  #post-content-ck-edit .image-style-align-right {
    /* display: flex; */
    /* justify-content: right; */
    float: inline-end;
    padding-left: 10px;
  }
  #post-content-ck-edit .image-style-align-left {
    /* display: flex; */
    /* justify-content: right; */
    float: inline-start;
    padding-right: 10px;
  }
  #post-content-ck-edit .text-big {
    font-size: xx-large;
    font-weight: 500;
    line-height: 1;
  }
  #post-content-ck-edit figcaption {
    opacity: 70%;
    font-size: 12px;
    font-style: oblique;
    margin-bottom: 10px;
  }
  #post-content-ck-edit .media,
  iframe {
    width: 100%;
  }
  /* #post-content-ck-edit .media{
    width: 100%;
  } */
  /* .postPageByLine .author-details .author-details .news-time {} */
  .postPageByLine .author-details {
    display: flex;
    flex-direction: column;
    line-height: 18px;
    margin-bottom: 0;
  }
  .postPageByLine {
    width: 100%;
    display: flex;
    /* gap: 183px; */
    margin-bottom: 10px;
    justify-content: space-between;
    align-items: center;
  }
  .social-media-share-btns {
    display: flex;
    gap: 10px;
  }
  .social-media-share-btns,
  svg,
  button {
    /* color: #878787!important; */
  }
  .social-media-share-btns svg {
    width: 20px;
    /* color: #878787; */
    color: #6a6a6a !important;
  }
  @media (max-width: 405px) {
    .social-media-share-btns svg {
      width: 20px;
      color: #878787;
    }
    .social-media-share-btns {
      /* display: flex; */
      gap: 10px;
      /* align-items: baseline; */
    }
    .postPageByLine {
      align-items: end;
    }
    .postPageByLine .news-time {
      font-size: 12px !important;
      color: #a1a1a1;
    }
    .img-main {
      height: auto;
    }
  }
  .social-media-share-btns button {
    width: 24px;
    color: #878787;
  }
  /* .postPage-main .author-details{ */
  
  .postPage-main .iframely-embed {
    margin: auto;
  }
  .postPage-main .iframely-responsive {
    height: 560px !important;
  }
  .postPage-main .iframely-responsive iframe {
    height: 100% !important;
  }
  @media (max-width: 1220px) {
    .post-page-main-container {
      margin-top: 60px !important;
      padding: 0 !important;
    }
  }
.opinion-main {
  width: 75% !important;
  margin: auto;
  margin-top: 130px;
  height: 100%;
}
.opinion-container {
  display: flex;
}
.opinion-left {
  width: 65%;
}
.opinion-right {
  width: 35%;
}
.opinion-container hr {
  width: 3px;
  height: 100%;
  background: rgb(155, 149, 149);
  margin: 5px;
}
.opinionPagenation {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}
.pagination a {
  color: black;
  font-size: 12px;
  font-weight: 500;
}
.pagination a:active {
  box-shadow: none;
}
.pagination a:focus {
  box-shadow: none;
}
.postHeading {
  color: #000;
  leading-trim: both;
  text-edge: cap;

  /* H1-switzer-inner-40-bold */
  font-family: "Switzer-variable";
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px; /* 125% */
}
.inner-category-btn {
  display: inline-flex;
  /* height: 40px; */
  padding: 0px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #bebebe;
  background: #fff;
  margin: 5px 10px 10px 0px;

  leading-trim: both;
  text-transform: capitalize;
  text-edge: cap;
  font-family: "Alumni Sans" !important;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 127.273% */
}
.inner-category-btn:focus {
  background: var(--Primary, #e82327) !important;
  color: #fff;
}
.opinionTop-main-flex-world {
  /* padding: 10px;
  border: 1px solid gray; */
  /* border-radius: 10px; */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
}
.world-videos-section-main {
  width: 990px;
  height: 731px;
  flex-shrink: 0;
  border-radius: 20px;
  background: #090909;
}


@media(max-width:500px){
   .postHeading{
    font-size: 24px!important;
    line-height: 28px;
   }
   .post-heading-container p{
    font-size: 14px;
   }
   #post-content-ck-edit{
    line-height: 24px!important;
   }
}`, "",{"version":3,"sources":["webpack://./src/Component/preview.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,uCAAuC;IACvC,iCAAiC;IACjC,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,UAAU;IACV,iBAAiB;IACjB,4BAA4B;EAC9B;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE;oBACgB;IAChB,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,sCAAsC;IACtC,iCAAiC;IACjC,eAAe;IACf,eAAe;IACf,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,oBAAoB;IACpB,4BAA4B;IAC5B,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,eAAe;IACf,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;EACpB;EACA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;EACf;EACA;IACE;MACE,aAAa;IACf;EACF;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,mBAAmB;EACrB;EACA;;IAEE,WAAW;EACb;EACA;;KAEG;EACH,kEAAkE;EAClE;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,SAAS;EACX;EACA;;;IAGE,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,yBAAyB;EAC3B;EACA;IACE;MACE,WAAW;MACX,cAAc;IAChB;IACA;MACE,mBAAmB;MACnB,SAAS;MACT,2BAA2B;IAC7B;IACA;MACE,gBAAgB;IAClB;IACA;MACE,0BAA0B;MAC1B,cAAc;IAChB;IACA;MACE,YAAY;IACd;EACF;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA,oCAAoC;;EAEpC;IACE,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE;MACE,2BAA2B;MAC3B,qBAAqB;IACvB;EACF;AAMF;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;;EAEd,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;;EAEzB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,8CAA8C;EAC9C,WAAW;AACb;AACA;EACE;2BACyB;EACzB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;GACG;IACC,yBAAyB;IACzB,iBAAiB;GAClB;GACA;IACC,eAAe;GAChB;GACA;IACC,2BAA2B;GAC5B;AACH","sourcesContent":[".postPageAdContainer {\n    /* border: 1px solid black; */\n    margin: 10px 0;\n  }\n  .postPageAdContainer img {\n    width: 100%;\n  }\n  .news-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    align-items: center;\n    /* padding: 1rem 0; */\n    /* border-bottom: 2px dotted #bdbdbd; */\n    border-bottom: 1px dotted #122241;\n    /* margin-bottom: 14px; */\n  }\n  .news-heading h2 {\n    font-family: \"Satoshi\";\n    font-size: 18px !important;\n    font-style: normal;\n    text-transform: uppercase !important;\n    font-weight: 700;\n    margin-bottom: 4px;\n    /* line-height: 0rem; */\n    /* display: block; */\n    min-width: 30%;\n    /* letter-spacing: 1px; */\n  }\n  .news-heading hr {\n    /* width: 75%; */\n    height: 1px;\n    /* max-width: 490px; */\n    width: 65%;\n    /* height: 1px; */\n    background: rgba(0, 0, 0, 1);\n  }\n  .post-related-news {\n    /* background: #fafafa; */\n    padding: 5px;\n    border-radius: 5px;\n  }\n  .post-related-news .opinionLatestRight {\n    width: 49%;\n  }\n  .news-content {\n    /* background: #f5f5f5;\n    padding: 16px; */\n    border-radius: 8px;\n  }\n  .news-content ul {\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin: 0px;\n  }\n  .news-content ul li {\n    width: 48%;\n    list-style: none;\n    font-family: \"Switzer-variable\";\n    font-size: 0.875rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 1.375rem;\n    /* border-bottom: solid 1px #cacaca; */\n    border-bottom: 1px dotted #122241;\n    padding: 10px 0;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n  }\n  .news-content ul li h3 {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    font-size: 16px !important;\n    line-height: 22px;\n    -webkit-line-clamp: 3;\n    color: #000;\n    margin: 0px;\n  }\n  \n  .postPage-main div {\n    display: flex;\n    justify-content: space-between;\n    border-radius: 6px;\n    background: #f8f8f8;\n    /* padding: 5px 10px; */\n  }\n  .breadcrumb-item a {\n    text-transform: capitalize;\n    font-size: 12px;\n    color: black;\n    opacity: 100%;\n    font-weight: 500;\n  }\n  .post-page-main-container {\n    margin-top: 10px !important;\n  }\n  \n  .postPage-main blockquote {\n    padding-left: 15px;\n    border-left: 7px solid #ccc7c7;\n    border-radius: 2px;\n  }\n  .postPage-main .text-huge {\n    font-size: xxx-large;\n    font-weight: 800;\n    line-height: 1;\n  }\n  .postPage-main h4 .image-style-align-left {\n    vertical-align: baseline;\n  }\n  .img-main {\n    width: 100%;\n    border-radius: 6px;\n    border: 1px solid #000;\n    /* margin: 10px 0; */\n    margin: 0px 0px 0px 0px;\n    object-fit: cover;\n    object-position: center 25%;\n    /* height: 282px; */\n    height: 380px;\n  }\n  @media (max-width: 600px) {\n    .img-main {\n      height: 210px;\n    }\n  }\n  .postPage-main .text-small {\n    font-size: 13px;\n  }\n  .postPage-main .big-img-container {\n    display: block !important;\n  }\n  #post-content-ck-edit figure div {\n    /* background: green !important; */\n  }\n  .media div {\n    /* background: white !important; */\n  }\n  .post-img-caption {\n    opacity: 70%;\n    font-size: 12px;\n    font-style: oblique;\n    margin-bottom: 10px;\n  }\n  .image img {\n    max-width: 95% !important;\n    height: 100%;\n  }\n  .postPageByLine .author-details .author-name span {\n    font-size: 14px !important;\n  }\n  .postPageByLine .author-details {\n    font-size: 12px !important;\n  }\n  .postPageByLine .news-time {\n    font-size: 12px !important;\n  }\n  #post-content-ck-edit {\n    font-family: \"Switzer-Variable\";\n    line-height: 28px;\n  }\n  \n  #post-content-ck-edit img {\n    max-width: 98%;\n    height: auto;\n  }\n  \n  #post-content-ck-edit .table table {\n    border-collapse: collapse;\n    width: 100%;\n  }\n  #post-content-ck-edit .table table td {\n    border: 1px solid black;\n    padding: 6px;\n    text-align: left;\n    font-size: 14px;\n    line-height: 22px;\n  }\n  #post-content-ck-edit .table table td p {\n    margin: 0px;\n    font-size: 14px !important;\n  }\n  #post-content-ck-edit .image-style-align-center {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n  }\n  #post-content-ck-edit .image-style-align-right {\n    /* display: flex; */\n    /* justify-content: right; */\n    float: inline-end;\n    padding-left: 10px;\n  }\n  #post-content-ck-edit .image-style-align-left {\n    /* display: flex; */\n    /* justify-content: right; */\n    float: inline-start;\n    padding-right: 10px;\n  }\n  #post-content-ck-edit .text-big {\n    font-size: xx-large;\n    font-weight: 500;\n    line-height: 1;\n  }\n  #post-content-ck-edit figcaption {\n    opacity: 70%;\n    font-size: 12px;\n    font-style: oblique;\n    margin-bottom: 10px;\n  }\n  #post-content-ck-edit .media,\n  iframe {\n    width: 100%;\n  }\n  /* #post-content-ck-edit .media{\n    width: 100%;\n  } */\n  /* .postPageByLine .author-details .author-details .news-time {} */\n  .postPageByLine .author-details {\n    display: flex;\n    flex-direction: column;\n    line-height: 18px;\n    margin-bottom: 0;\n  }\n  .postPageByLine {\n    width: 100%;\n    display: flex;\n    /* gap: 183px; */\n    margin-bottom: 10px;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .social-media-share-btns {\n    display: flex;\n    gap: 10px;\n  }\n  .social-media-share-btns,\n  svg,\n  button {\n    /* color: #878787!important; */\n  }\n  .social-media-share-btns svg {\n    width: 20px;\n    /* color: #878787; */\n    color: #6a6a6a !important;\n  }\n  @media (max-width: 405px) {\n    .social-media-share-btns svg {\n      width: 20px;\n      color: #878787;\n    }\n    .social-media-share-btns {\n      /* display: flex; */\n      gap: 10px;\n      /* align-items: baseline; */\n    }\n    .postPageByLine {\n      align-items: end;\n    }\n    .postPageByLine .news-time {\n      font-size: 12px !important;\n      color: #a1a1a1;\n    }\n    .img-main {\n      height: auto;\n    }\n  }\n  .social-media-share-btns button {\n    width: 24px;\n    color: #878787;\n  }\n  /* .postPage-main .author-details{ */\n  \n  .postPage-main .iframely-embed {\n    margin: auto;\n  }\n  .postPage-main .iframely-responsive {\n    height: 560px !important;\n  }\n  .postPage-main .iframely-responsive iframe {\n    height: 100% !important;\n  }\n  @media (max-width: 1220px) {\n    .post-page-main-container {\n      margin-top: 60px !important;\n      padding: 0 !important;\n    }\n  }\n\n  \n\n\n  @import url(\"https://fonts.googleapis.com/css2?family=Alumni+Sans:wght@400;500;600;800&family=Roboto:wght@300&display=swap\");\n.opinion-main {\n  width: 75% !important;\n  margin: auto;\n  margin-top: 130px;\n  height: 100%;\n}\n.opinion-container {\n  display: flex;\n}\n.opinion-left {\n  width: 65%;\n}\n.opinion-right {\n  width: 35%;\n}\n.opinion-container hr {\n  width: 3px;\n  height: 100%;\n  background: rgb(155, 149, 149);\n  margin: 5px;\n}\n.opinionPagenation {\n  display: flex;\n  justify-content: center;\n  margin-top: 2rem;\n}\n.pagination a {\n  color: black;\n  font-size: 12px;\n  font-weight: 500;\n}\n.pagination a:active {\n  box-shadow: none;\n}\n.pagination a:focus {\n  box-shadow: none;\n}\n.postHeading {\n  color: #000;\n  leading-trim: both;\n  text-edge: cap;\n\n  /* H1-switzer-inner-40-bold */\n  font-family: \"Switzer-variable\";\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 44px; /* 125% */\n}\n.inner-category-btn {\n  display: inline-flex;\n  /* height: 40px; */\n  padding: 0px 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  border: 1px solid #bebebe;\n  background: #fff;\n  margin: 5px 10px 10px 0px;\n\n  leading-trim: both;\n  text-transform: capitalize;\n  text-edge: cap;\n  font-family: \"Alumni Sans\" !important;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 28px; /* 127.273% */\n}\n.inner-category-btn:focus {\n  background: var(--Primary, #e82327) !important;\n  color: #fff;\n}\n.opinionTop-main-flex-world {\n  /* padding: 10px;\n  border: 1px solid gray; */\n  /* border-radius: 10px; */\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 10px;\n}\n.world-videos-section-main {\n  width: 990px;\n  height: 731px;\n  flex-shrink: 0;\n  border-radius: 20px;\n  background: #090909;\n}\n\n\n@media(max-width:500px){\n   .postHeading{\n    font-size: 24px!important;\n    line-height: 28px;\n   }\n   .post-heading-container p{\n    font-size: 14px;\n   }\n   #post-content-ck-edit{\n    line-height: 24px!important;\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
